/*
Still in the process of being converted to vanilla js

## Done
checkBlanks
checkEmail
minLength
passwordCheck
isChecked
*/

class Validator {
  constructor() {
    //
  }

  clearErrors(form) {
    $('' + form)
      .find('.error')
      .each(function (index, el) {
        $(el).removeClass('error')
      })
  }

  checkBlanks(fields, nextlevel) {
    let status = true

    fields.forEach((fieldItem) => {
      const field = document.querySelector(fieldItem.id)

      if (!field) {
      } else if (field.value && field.value !== '' && field.value.length > 0) {
        field.parentNode.classList.remove('error')

        if (nextlevel) {
          field.parentNode.parentNode.classList.remove('error')
        }
      } else {
        field.parentNode.classList.add('error')

        if (nextlevel) {
          field.parentNode.parentNode.classList.add('error')
        }

        status = false
      }
    })

    return status
  }

  checkBlanksSimple(fields, nextlevel) {
    let status = true

    fields.forEach((fieldItem) => {
      const field = document.querySelector(fieldItem.id)

      if (!field) {
      } else if (
        field.value &&
        field.value.trim() !== '' &&
        field.value.length > 0
      ) {
      } else {
        status = false
      }
    })

    return status
  }

  checkCurrency(fields, nextlevel) {
    let status = true

    fields.forEach((fieldItem) => {
      const field = document.querySelector(fieldItem.id)

      if (!field) {
      } else if (
        field.value &&
        field.value !== '' &&
        field.value !== '$' &&
        field.value.length > 1
      ) {
        field.parentNode.classList.remove('error')

        if (nextlevel) {
          field.parentNode.parentNode.classList.remove('error')
        }
      } else {
        field.parentNode.classList.add('error')

        if (nextlevel) {
          field.parentNode.parentNode.classList.add('error')
        }

        status = false
      }
    })

    return status
  }

  checkCurrencySimple(fields, nextlevel) {
    let status = true

    fields.forEach((fieldItem) => {
      const field = document.querySelector(fieldItem.id)

      if (!field) {
      } else if (
        field.value &&
        field.value !== '' &&
        field.value !== '$' &&
        field.value.length > 1
      ) {
      } else {
        status = false
      }
    })

    return status
  }

  checkEmail(field) {
    const fieldEl = document.querySelector(field)
    if (!fieldEl) {
      return true
    }
    const email = fieldEl.value
    const x = email
    const atpos = x.indexOf('@')
    const dotpos = x.lastIndexOf('.')
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= x.length) {
      fieldEl.parentNode.classList.add('error')
      return false
    }

    fieldEl.parentNode.classList.remove('error')
    return true
  }

  checkEmailSimple(field) {
    const fieldEl = document.querySelector(field)
    if (!fieldEl) {
      return true
    }
    const email = fieldEl.value
    const x = email
    const atpos = x.indexOf('@')
    const dotpos = x.lastIndexOf('.')
    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= x.length) {
      return false
    }

    return true
  }

  checkPhone(field) {
    const fieldEl = document.querySelector(field)
    if (!fieldEl) {
      return true
    }

    const regex = RegExp('^\\([2-9][0-9]{2}\\) [0-9]{3}-[0-9]{4}$')
    const ok = regex.test(fieldEl.value)

    if (ok) {
      fieldEl.parentNode.classList.remove('error')
    } else {
      fieldEl.parentNode.classList.add('error')
    }

    return ok
  }

  matchFields(fields, minLength) {
    var status = true

    var val1 = $('' + fields[0]).val()
    var val2 = $('' + fields[1]).val()

    if (val1 != val2) {
      status = false
    } else {
      _.each(fields, function (field) {
        if ($('' + field).val().length < length) {
          status = false
        }
      })
    }

    if (status) {
      $('' + fields[0])
        .parent()
        .removeClass('error')
      $('' + fields[1])
        .parent()
        .removeClass('error')
    } else {
      $('' + fields[0])
        .parent()
        .addClass('error')
      $('' + fields[1])
        .parent()
        .addClass('error')
    }

    return status
  }

  passwordCheck(fields, errorFields, minLength) {
    let status = true
    let msg = 'Passwords must match'

    const val1 = document.querySelector(fields[0]).value
    const val2 = document.querySelector(fields[1]).value

    if (val1 != val2) {
      status = false
    } else {
      if (val1.length < minLength || val2.length < minLength) {
        status = false
        msg = 'Password must be at least 8 characters'
      }
    }

    if (status) {
      document.querySelector(fields[0]).parentNode.classList.remove('error')
      document.querySelector(fields[1]).parentNode.classList.remove('error')

      document.querySelector(errorFields[0]).innerHTML =
        'Please enter a password'
      document.querySelector(errorFields[1]).innerHTML =
        'Please confirm your password'
    } else {
      document.querySelector(errorFields[0]).innerHTML = msg
      document.querySelector(errorFields[1]).innerHTML = msg

      document.querySelector(fields[0]).parentNode.classList.add('error')
      document.querySelector(fields[1]).parentNode.classList.add('error')
    }

    return status
  }

  /*
   * fields = array of objects: {selector:[selector], length: [int]}
   */
  minLength(fields) {
    let status = true
    fields.forEach((fieldItem) => {
      const el = document.querySelector(fieldItem.selector)
      if (el.value.length != fieldItem.length) {
        el.parentNode.classList.add('error')
        status = false
      } else {
        el.parentNode.classList.remove('error')
      }
    })

    return status
  }

  isChecked(fields) {
    let status = true

    fields.forEach((fieldItem) => {
      const el = document.querySelector(fieldItem)

      if (el.checked) {
        el.parentNode.classList.remove('error')
        status = true
      } else {
        el.parentNode.classList.add('error')
        status = false
      }
    })

    return status
  }

  maxWords(fields, length) {
    var status = true
    _.each(fields, function (field) {
      var value = $('' + field).val()
      var regex = /\s+/gi
      count = value.trim().replace(regex, ' ').split(' ').length

      if (count > length) {
        $('' + field)
          .parent()
          .addClass('error')
        status = false
      } else {
        $('' + field)
          .parent()
          .removeClass('error')
      }
    })

    return status
  }

  blockFor(field, words) {
    var ok = true
    for (var i = 1; i <= words.length; ++i) {
      var label = $('' + field)
        .val()
        .toLowerCase()
      var word = words[i - 1].toLowerCase()

      if (label.indexOf(word) !== -1) {
        ok = false
      }
    }

    if (ok) {
      $('' + field)
        .parent()
        .removeClass('error')
    } else {
      $('' + field)
        .parent()
        .addClass('error')
      $('' + field).val('')
    }

    return ok
  }
}

export default Validator
